import _reduce from 'lodash/reduce'
import Menu, { MenuItem } from 'material-ui/Menu'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../../../imports'

class LanguageSelection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            anchorEl: null,
            open: false,
        }
    }

    handleClick = (event) => {
        this.setState({ open: true, anchorEl: event.currentTarget })
    }

    handleMenuItemClick = (newValue) => {
        this.setState({ open: false })

        this.update(newValue)
    }

    handleRequestClose = () => {
        this.setState({ open: false })
    }

    update = (newValue) => {
        // Make sure English is not an empty string
        const value = newValue === '' ? 'en' : newValue

        // If the value is unchanged, don't update
        if (value === this.props.value) {
            return
        }

        this.props.update(newValue)
    }

    render() {
        const items = _reduce(
            this.props.languages,
            (r, v, k) => {
                const settings = {
                    key: k,
                    selected: k === this.props.value,
                    onClick: () => this.handleMenuItemClick(k),
                }
                r.push(<MenuItem {...settings}>{v}</MenuItem>)
                return r
            },
            [],
        )

        return (
            <div>
                <h4>{this.props.label}</h4>
                <Button block onClick={this.handleClick}>
                    {this.props.languages[this.props.value]} <i className="fa fa-caret-down" />
                </Button>
                <Menu
                    id="simple-menu"
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onRequestClose={this.handleRequestClose}
                >
                    {items}
                </Menu>
            </div>
        )
    }
}

LanguageSelection.propTypes = {
    languages: PropTypes.shape({
        id: PropTypes.string,
        value: PropTypes.string,
    }),
    label: PropTypes.string,
    value: PropTypes.string,
    update: PropTypes.func,
}

export default LanguageSelection



// WEBPACK FOOTER //
// ./src/features/Settings/components/Settings/components/LanguageSelection/component.js